import React from "react";

import defaultProfilePic from "../../../assets/images/anonymous.jpg.webp"


const TraderCardAPI = ({ trader, index }) => {
    const IMAGE_BASE = process.env.REACT_APP_BASE_URL_IMAGE;


    return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 hover:shadow-lg transition">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full">
            <span className="font-bold text-sm">{index + 1}</span>
          </div>

          <img
            src={trader.imageId?.path ? IMAGE_BASE + trader.imageId.path : defaultProfilePic}
            alt={trader.fullName || trader.userName || "Trader"}
            className="w-12 h-12 rounded-xl object-cover"
          />

          <div>
            <h3 className="font-semibold text-dark">
              {trader.fullName || trader.userName || "Unknown"}
            </h3>

            <p className="text-gray-500 text-xs">
              {trader.signalCount} Signals
            </p>
          </div>
        </div>

        <div className="text-right">
          <p className="text-lg font-bold text-green-600">{trader.point}</p>

          <p className="text-gray-500 text-xs">Points</p>
        </div>
      </div>
    </div>
  );
};

export default TraderCardAPI;
